mappedFilters